// TODO - remove lint disable when editing this file
/* eslint-disable */
import { Observable } from 'rxjs'
import { ACTION_ROUTE_CHANGING, getCurrentRoute } from '~/redux/routeReducer'
import { saveAction } from '~/redux/draftEditor'
import {
  storyLockedOrReadonlyAccessor,
  ACTION_STORY_LOADED,
} from '~/redux/appReducer'

export default (action$, store, { serviceResolver }) =>
  action$
    .filter((action) => {
      // Exclude template since it's not compatible with the saveAction
      return (
        action.type === ACTION_STORY_LOADED &&
        !!(getCurrentRoute(store.getState()) || '').indexOf('/template')
      )
    })
    .ofType(ACTION_STORY_LOADED)
    .switchMap(() => {
      return Observable.fromEvent(document, 'visibilitychange')
        .takeUntil(action$.ofType(ACTION_ROUTE_CHANGING))
        .filter(() => document.visibilityState === 'hidden')
    })
    .filter(() => {
      const storyService = serviceResolver('storyService')
      return (
        !storyLockedOrReadonlyAccessor(store.getState()) &&
        storyService.isDirty()
      )
    })
    .map(() => {
      return saveAction()
    })
